<template>
  <div
    class="menu-page-desktop"
    :class="{ 'menu-page-mobile': $route.meta.mobile }"
  >
    <h1>{{ $t("how-to-use.title") }}</h1>
    <p>{{ $t("how-to-use.p1") }}</p>

    <p>
      <span class="icon">
        <span class="icon-image icon-image-large center">
          <img src="../images/hotspots-icon@2x.png" /><br />
        </span>
        <span class="icon-name center">{{ $t("how-to-use.title2") }}</span>
      </span>
      {{ $t("how-to-use.p2") }}
    </p>

    <hr />

    <p>
      <span class="icon">
        <span class="icon-image icon-image-large center">
          <img src="../images/gyroscope-icon@2x.png" /><br />
        </span>
        <span class="icon-name center">{{ $t("how-to-use.title3") }}</span>
      </span>
      {{ $t("how-to-use.p3") }}
    </p>

    <hr />

    <p>
      <span class="icon">
        <span class="icon-image icon-image-large center">
          <img src="../images/5D-icon@2x.png" /><br />
        </span>
        <span class="icon-name center">{{ $t("how-to-use.title4") }}</span>
      </span>
      {{ $t("how-to-use.p4") }}
    </p>
    <p>{{ $t("how-to-use.p5") }}</p>

    <hr />

    <div style="width: 100%; padding-bottom: 5px; height: 25px">
      <span class="icon">
        <span
          class="icon-image center"
          style="width: 25%; display: block; float: left"
        >
          <img src="../images/tempel-icon@2x.png" /><br />
        </span>
      </span>

      <span class="icon">
        <span
          class="icon-image center"
          style="width: 25%; display: block; float: left"
        >
          <img src="../images/religion-icon@2x.png" /><br />
        </span>
      </span>

      <span class="icon">
        <span
          class="icon-image center"
          style="width: 25%; display: block; float: left"
        >
          <img src="../images/money-icon@2x.png" /><br />
        </span>
      </span>

      <span class="icon">
        <span
          class="icon-image center"
          style="width: 25%; display: block; float: left"
        >
          <img src="../images/bread-icon@2x.png" /><br />
        </span>
      </span>
    </div>
    <p>
      <span class="icon">
        <span class="center">
          <span class="icon-name">{{ $t("how-to-use.title5") }}</span>
        </span>
      </span>
      {{ $t("how-to-use.p6") }}
    </p>

    <ul>
      <li>{{ $t("how-to-use.ul-themas-li-1") }}</li>
      <li>{{ $t("how-to-use.ul-themas-li-2") }}</li>
      <li>{{ $t("how-to-use.ul-themas-li-3") }}</li>
      <li>{{ $t("how-to-use.ul-themas-li-4") }}</li>
      <li>{{ $t("how-to-use.ul-themas-li-5") }}</li>
      <li>{{ $t("how-to-use.ul-themas-li-6") }}</li>
      <li>{{ $t("how-to-use.ul-themas-li-7") }}</li>
      <li>{{ $t("how-to-use.ul-themas-li-8") }}</li>
      <li>{{ $t("how-to-use.ul-themas-li-9") }}</li>
      <li>{{ $t("how-to-use.ul-themas-li-10") }}</li>
      <li>{{ $t("how-to-use.ul-themas-li-11") }}</li>
    </ul>

    <hr />

    <p>
      <span class="icon">
        <span class="icon-image center">
          <img src="../images/search-icon@2x.png" /><br />
        </span>
        <span class="icon-name center">{{ $t("how-to-use.title6") }}</span>
      </span>
      {{ $t("how-to-use.p7") }}
    </p>

    <hr />

    <p>
      <span class="icon">
        <span class="icon-image center">
          <img src="../images/expert-icon@2x.png" /><br />
        </span>
        <span class="icon-name center">{{ $t("how-to-use.title7") }}</span>
      </span>
      {{ $t("how-to-use.p8") }}
    </p>

    <hr v-if="$route.meta.mobile" />
    <p v-if="$route.meta.mobile">
      <span class="icon">
        <span class="icon-name center">
          {{ $t("how-to-use.title8") }}
        </span>
      </span>
      {{ $t("how-to-use.p9") }}
    </p>

    <hr />
    <page-footer />
  </div>
</template>

<script>
import PageFooter from "@/components/menus/pages/PageFooter.vue";

export default {
  components: {
    PageFooter
  },
  head: {
    meta: [
      {
        name: "viewport",
        content: "width=device-width, shrink-to-fit=YES",
        initialScale: "1.0",
        maximumScale: "1.0",
        minimumScale: "1.0",
        userScalable: "no"
      }
    ]
  }
};
</script>

<style scoped src="../css/main.css"></style>
